export enum ItemWeaponHand {
  left = "lewa",
  right = "prawa",
  twoHanded = "dwureczna",
  bothHanded = "w dowolnej rece",
  oneAndHalfHanded = "poltorareczna",
}
